/* eslint-disable eqeqeq */
import { createSelector } from 'reselect';

import { BLACKJACK_VIDEOCHAT_ID, RUSSIAN_POKER_ID } from '@ezugi/constants';

import { RootState } from '../types';

const gameSelector = (state: RootState) => state.game ?? {};

const gameIdSelector = createSelector(
  gameSelector,
  (game) => game.gameId
);

// Blackjack Video Chat
export const isBJVCSelector = createSelector(
  gameIdSelector,
  (gameId) => gameId == BLACKJACK_VIDEOCHAT_ID,
);

export const isRussianPokerSelector = createSelector(
  gameIdSelector,
  (gameId) => gameId == RUSSIAN_POKER_ID,
);
